import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined"
import Chip from "@mui/material/Chip"
import { Link as RouterLink } from "react-router-dom"

import {
  inboxContactDetailsPath,
  inboxContactDisplayName,
} from "./inboxContactPath"

const LINKED_CONTACT_CHIP_SX = {
  bgcolor: "colors.brand50",
  color: "primary.dark",
  fontWeight: 600,
  textDecoration: "none",
  "& .MuiChip-icon": { color: "primary.main" },
}

const UNLINKED_CONTACT_CHIP_SX = {
  bgcolor: "colors.gray100",
  color: "colors.gray600",
}

export default function InboxContactChip({
  contact,
  fallbackLabel = null,
  unmatchedLabel = "Unmatched — not linked to a contact",
  size = "small",
}) {
  const detailsPath = inboxContactDetailsPath(contact)
  const label = inboxContactDisplayName(contact) || fallbackLabel

  if (detailsPath && label) {
    return (
      <Chip
        component={RouterLink}
        to={detailsPath}
        clickable
        size={size}
        icon={<PersonOutlineOutlinedIcon />}
        label={label}
        sx={LINKED_CONTACT_CHIP_SX}
      />
    )
  }

  if (label) {
    return (
      <Chip
        size={size}
        icon={<PersonOutlineOutlinedIcon />}
        label={label}
        sx={UNLINKED_CONTACT_CHIP_SX}
      />
    )
  }

  return (
    <Chip size={size} label={unmatchedLabel} sx={UNLINKED_CONTACT_CHIP_SX} />
  )
}
